import React from "react";

function Footer() {
  return (
    <footer className="container mx-auto py-4 text-center">
      <p className="text-xs">© 2026 Veerapathiran Dev. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
